import Adicionar from './Adicionar';
import AdicionarAdmin from './AdicionarAdmin';
import Aguardando from './Aguardando';
import Default from './Default';
import EditarAdmin from './EditarAdmin';

const IndisponibilidadesDefault = Default;

export default IndisponibilidadesDefault;
export const IndisponibilidadesAdicionar = Adicionar;
export const IndisponibilidadesAdicionarAdmin = AdicionarAdmin;
export const IndisponibilidadesEditarAdmin = EditarAdmin;
export const IndisponibilidadesAguardando = Aguardando;
